import { Provider } from '@angular/core';
import { FEEDBACK_PROCESSO_REPOSITORY } from './repositories/feedback-processo.repository';
import { FeedbackProcessoService } from './services/feedback-processo.service';

export const FEEDBACK_PROCESSO_PROVIDERS: Provider[] = [
  {
    provide: FEEDBACK_PROCESSO_REPOSITORY,
    useClass: FeedbackProcessoService
  }
];

